import { PlaylistAdd } from "@mui/icons-material";
import { Button } from "@mui/material";
import { AnimatePresence } from "motion/react";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { isMaxItemsReached } from "@ryde/shared";

import { emptyUserRole, IUserRoleItemForm } from "./table-user-roles.models";
import { UserRoleEdit } from "./user-role.edit";

export const UserRoleAdd: FC<Partial<IUserRoleItemForm>> = ({
  index,
  setValueOuter,
  fieldName,
  formAttributes,
  onEditStart,
  onEditEnd,
}) => {
  const { t } = useTranslation();
  const [isAddNewOpened, setAddNewOpenedState] = useState(false);
  const hideAppendButton = isMaxItemsReached(
    formAttributes?.maxItemsToAdd,
    index || 0,
  );

  useEffect(() => {
    if (isAddNewOpened) {
      onEditStart?.();
    } else {
      onEditEnd?.();
    }
  }, [isAddNewOpened, onEditStart, onEditEnd]);

  return (
    <>
      <AnimatePresence mode="wait">
        {isAddNewOpened && (
          <UserRoleEdit
            key="edit"
            fieldName={`${fieldName}[${index || 0}]`}
            setValueOuter={setValueOuter}
            value={emptyUserRole}
            index={index}
            formAttributes={formAttributes}
            onCancelOuter={() => {
              setAddNewOpenedState(false);
            }}
          />
        )}
      </AnimatePresence>
      {!isAddNewOpened && !hideAppendButton && (
        <Button
          type="button"
          size="medium"
          className="add_button"
          startIcon={<PlaylistAdd />}
          onClick={() => setAddNewOpenedState(true)}
        >
          {t("general.APPEND")}
        </Button>
      )}
    </>
  );
};
